import { useCallback, useEffect, useState } from 'react';

import { PlusCircleOutlined } from '@ant-design/icons';
import { Table, notification, Button, Divider, Popconfirm } from 'antd';
import { Link } from 'react-router-dom';

import employeesService from '../../../services/employees-service';
import EmployeeType from '../../../typings/EmployeeType';
import TitledCard from '../../layout-components/titled-card';
import Flex from '../../layouts/flex';

const EmployeesList: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [employees, setEmployees] = useState<Array<EmployeeType>>([]);

  const reloadList = () => {
    employeesService.getEmployees().then((response) => {
      setEmployees(response.employees);
      setLoading(false);
    });
  };

  useEffect(reloadList, []);

  const removeItem = useCallback((record: EmployeeType) => {
    setLoading(true);
    employeesService
      .deleteEmployee(record.id)
      .then(() => {
        notification.success({
          message: 'Usunięto redaktora',
          description: (
            <>
              Redaktor{' '}
              <strong>
                {record.first_name} {record.last_name}
              </strong>{' '}
              został usunięty.
            </>
          ),
        });
        reloadList();
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const columns = [
    {
      title: 'E-mail',
      dataIndex: 'email',
      render: (email: string, record: EmployeeType) => (
        <Link to={`${record.id}/edit`}>{email}</Link>
      ),
    },
    {
      title: 'Imię',
      dataIndex: 'first_name',
      align: 'center' as const,
      width: 250,
    },
    {
      title: 'Nazwisko',
      dataIndex: 'last_name',
      align: 'center' as const,
      width: 150,
    },
    {
      title: 'Operacje',
      key: 'action',
      width: 200,
      align: 'center' as const,
      render: (_text: string, record: EmployeeType) => (
        <span>
          <Link to={`${record.id}/edit`}>
            <Button type="primary" size="small">
              Edycja
            </Button>
          </Link>

          <Divider type="vertical" />

          <Popconfirm
            title={
              <>
                Czy na pewno usunąć redaktora{' '}
                <strong>
                  {record.first_name} {record.last_name}
                </strong>
                ?
              </>
            }
            onConfirm={() => removeItem(record)}
            okText="Tak"
            cancelText="Nie"
          >
            <Button type="primary" size="small" danger>
              Usuń
            </Button>
          </Popconfirm>
        </span>
      ),
    },
  ];

  return (
    <TitledCard title="Lista redaktorów">
      <Flex className="mb-3" alignItems="center" justifyContent="end" mobileFlex={false}>
        <div>
          <Link to="new">
            <Button type="primary" icon={<PlusCircleOutlined />} block>
              Dodaj redaktora
            </Button>
          </Link>
        </div>
      </Flex>
      <Table
        rowKey="id"
        dataSource={employees}
        columns={columns}
        bordered
        loading={loading}
        pagination={false}
      />
    </TitledCard>
  );
};
export default EmployeesList;
